import { Component } from '@angular/core';
import {Constants} from '../../../app.constants';

@Component({
  template: `<app-product-classification-list [url]="url" [translationKey]="'MENU.PRODUCTS.PRODUCT_ASSORTMENTS'"></app-product-classification-list>`
})
export class ProductAssortmentsListComponent {
  public url = `${Constants.contextPath}/product-assortments`;
}
